import { MenuItem, styled, TextField } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";
import {
  GRANULARITY_OPTIONS,
  type StatsFilter,
  TIME_RANGE_OPTIONS,
} from "./stats-time-filter";

const FilterSelect = styled(TextField)({
  minWidth: 148,
  "& .MuiInputBase-root": {
    backgroundColor: EPOCUS_WHITE,
    borderRadius: 8,
    fontSize: rem(13),
    fontWeight: 600,
    minHeight: 44,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: EPOCUS_BORDER,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: EPOCUS_PRIMARY,
  },
  "& .MuiInputLabel-root": {
    fontSize: rem(13),
    color: EPOCUS_TEXT_SECONDARY,
  },
  "& .MuiSelect-select:focus": {
    backgroundColor: "transparent",
  },
});

export const StatsFilterBar: FC<{
  filter: StatsFilter;
  onChange: (change: Partial<StatsFilter>) => void;
}> = ({ filter, onChange }) => (
  <>
    <FilterSelect
      select
      // An explicit id is what wires the MUI label to the select for screen
      // readers; without it v4 renders the label unassociated.
      id="stats-filter-range"
      size="small"
      variant="outlined"
      label="Time range"
      value={filter.range}
      onChange={(event) =>
        onChange({ range: event.target.value as StatsFilter["range"] })
      }
    >
      {TIME_RANGE_OPTIONS.map(({ key, label }) => (
        <MenuItem key={key} value={key} style={{ fontSize: rem(13) }}>
          {label}
        </MenuItem>
      ))}
    </FilterSelect>

    <FilterSelect
      select
      id="stats-filter-granularity"
      size="small"
      variant="outlined"
      label="Trend by"
      value={filter.granularity}
      onChange={(event) =>
        onChange({
          granularity: event.target.value as StatsFilter["granularity"],
        })
      }
    >
      {GRANULARITY_OPTIONS.map(({ key, label }) => (
        <MenuItem key={key} value={key} style={{ fontSize: rem(13) }}>
          {label}
        </MenuItem>
      ))}
    </FilterSelect>
  </>
);
